import { useCallback, useEffect, useState } from 'react';
import useIsomorphicLayoutEffect from 'client/hooks/useIsomorphicLayoutEffect';

const useActiveFacetScroll = (isFacetActive: boolean, facetRef: React.RefObject<HTMLDivElement>) => {
  const [isActive, setIsActive] = useState(isFacetActive);

  useEffect(() => {
    setIsActive(isFacetActive);
  }, [isFacetActive]);

  const isOutOfViewport = useCallback((element: Element | null): element is Element => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.top < 0;
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (isActive && isOutOfViewport(facetRef.current)) {
      facetRef.current.scrollIntoView();
    }
  }, [facetRef, isActive, isOutOfViewport]);
};

export default useActiveFacetScroll;
